import { API_AUTH } from "./common";

const KiemKhoApi = {
  // list: ({
  //   tenKH,
  //   loaiKH,
  //   tinhtrangKH,
  //   trangthaiKH,
  //   nguonKH,
  //   pageIndex,
  //   pageSize,
  // }) =>
  //   API_AUTH.get(
  //     `quanlytaisan/danh-sach-kiem-kho?tenKH=${tenKH}&loaiKH=${loaiKH}&tinhtrangKH=${tinhtrangKH}&trangthaiKH=${trangthaiKH}&nguonKH=${nguonKH}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
  //     {}
  //   ),
  list: ({ maTaiSan, kho, trangThai, pageIndex, pageSize }) =>
    API_AUTH.get(
      `quan-ly-tai-san/danh-sach-kiem-kho?maTaiSan=${maTaiSan}&kho=${kho}&trangThai=${trangThai}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  list1: ({ dataSearch }) =>
    API_AUTH.get(
      `quan-ly-tai-san/danh-sach-kiem-kho1`,
      {dataSearch}
    ),
  phanquyenKiemKho: () =>
    API_AUTH.get(`quan-ly-tai-san/phan-quyen-danh-sach-kiem-kho`, {}),
  luuKiemKho: () => API_AUTH.get(`quan-ly-tai-san/luu-kiem-kho`, {}),
  luuKiemKho1: (LstDaKiemKho) => API_AUTH.post(`quan-ly-tai-san/luu-kiem-kho1`, LstDaKiemKho),
};

export default KiemKhoApi;
